module.exports = __webpack_public_path__ + "img/discount.5202ea3f.png";